<template>
    <div>
        <el-dialog :title="isAudit ? '审核' : '申请授权'" :visible.sync="dialogVisible" width="40%">
            <div class="dialogBox">
            <el-form ref="auditForm" :model="auditForm" label-width="90px" class="form">
                <el-form-item :label="isAudit ? '意见：' : '描述：'" style="width:90%;">
                <el-input type="textarea" :rows="4" v-model="auditForm.suggest"></el-input>
                </el-form-item>
            </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
                <el-button type="primary" @click="auditProcess"  style="margin-bottom:20px;">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        isAudit: {
            type: Boolean,
            default: false
        },
        processinstanceid: {
            type: String,
            default: ''
        },
        msg: {
            type: String,
            default: ''
        },
        commitStatus: {
            type: Boolean,
            default: false
        },
        applyStatus: {
            type: [Number, String],
            default: 0
        }
    },
    mounted() {
        this.auditForm.suggest = this.msg
    },
    data() {
        return {
            dialogVisible: false,
            auditForm: {
                suggest: ''
            }
        }
    },
    methods: {
        show(params) {
            if (this.isAudit) {
                this.dialogVisible = true
                return
            }
            const {tenderProjectCode, id, tenderProjectName} = params
            const text = `确定申请${tenderProjectName}项目的专家信息查看权限吗？`
            this.$confirm(text, '二次确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((action) => {
                if (action === 'confirm') {
                    this.dialogVisible = true
                }
            })
            // this.$http.get(`/expertController/examine?tenderCode=${tenderProjectCode}&entityId=${id}`).then(res => {
            //     if (res.data.code === '1') {
            //         const text = `确定申请${tenderProjectName}项目的专家信息查看权限吗？`
            //         this.$confirm(text, '二次确认', {
            //             confirmButtonText: '确定',
            //             cancelButtonText: '取消',
            //             type: 'warning'
            //         }).then((action) => {
            //             if (action === 'confirm') {
            //                 this.dialogVisible = true
            //             }
            //         })
            //     } else {
            //         this.$message.error(res.data.msg)
            //     }
            // })
        },
        close() {
            this.dialogVisible = false
        },
        auditProcess() {
            if (this.isAudit) {
                this.$http.post(`/expertController/submitWorkFlow`, {
                    id: this.id,
                    processinstanceid: this.processinstanceid,
                    variables: {
                        commit: this.commitStatus,
                        opinion: this.auditForm.suggest
                    }
                }).then(res => {
                    if (res.data.code == '1') {
                        this.$message.success('操作成功');
                        this.dialogVisible = false
                        this.$refs.auditForm.resetFields()
                        this.auditForm.suggest = ''
                        this.$emit('refresh')
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
                return
            }
            // 审核提交
            this.$http.post(`/expertController/${this.applyStatus == 4 ? 'submitWorkFlow':'startWorkFlow'}`, {
                id: this.id,
                processinstanceid: this.processinstanceid,
                variables: {
                    commit: true,
                    opinion: this.auditForm.suggest
                }
            }).then(res => {
                if (res.data.code == 1) {
                    this.$refs.auditForm.resetFields()
                    this.auditForm.suggest = ''
                    this.dialogVisible = false
                    this.$emit('refresh')
                } else {
                    this.$message.error(res.data.msg)

                }
            })
        }
    },
}
</script>